// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const decreaseBusyCounter = () => ({
    type: actions.DECREASE_PART_REQUESTS_SEARCH_BUSY_COUNTER
});

export const increaseBusyCounter = () => ({
    type: actions.INCREASE_PART_REQUESTS_SEARCH_BUSY_COUNTER
});



// WEBPACK FOOTER //
// ./src/part-requests/search/action-creators/busy-counter.js